// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"3608fa13","100":"2c43aa15","112":"b206e4f3","116":"3ea700c2","132":"ecab0a22","204":"c5132877","292":"4ecb0d3d","328":"aea3524b","376":"b0668e9b","380":"395692bf","472":"2ffed880","836":"42907ebf","996":"da275cfa"}[chunkId] + ".chunk.js";
};